import { minutesFromDayStart } from "../../journal/journal-time"

/**
 * Обратное преобразование к minutesFromDayStart: календарная дата филиала плюс минуты
 * на его часах → момент времени.
 *
 * ЗАЧЕМ. Форма 5-М8 работает в минутах («записать на 14:15»), а POST /v1/cabinet/appointments
 * принимает Instant. Перехода в эту сторону в journal/journal-time.ts нет — там он
 * не нужен: журнал только читает.
 *
 * ПОЧЕМУ ДВА ПРИБЛИЖЕНИЯ, А НЕ ВЫЧИТАНИЕ СМЕЩЕНИЯ. Смещение зоны непостоянно: в день
 * перевода часов сутки длятся 23 или 25 часов, и одно вычитание промахивается ровно
 * тогда, когда расписание и так перепутано. Первое приближение снимает смещение, второе
 * проверяет результат и правит остаток. Третьего не нужно: переводы часов идут шагом
 * не меньше получаса и дважды за одни сутки не случаются.
 *
 * В России переводов нет с 2014 года, и соблазн посчитать «просто минус три часа» велик.
 * Он неверен уже сегодня: Калининград, Самара и Владивосток — один салон в сети,
 * и смещение у них разное.
 */
export function zonedInstant(date: string, minute: number, timeZone: string): string {
  const base = Date.parse(`${date}T00:00:00Z`)
  if (Number.isNaN(base)) return new Date().toISOString()

  const guess = base + minute * 60_000
  const shown = minutesFromDayStart(new Date(guess).toISOString(), timeZone, date)
  const corrected = guess - (shown - minute) * 60_000

  const check = minutesFromDayStart(new Date(corrected).toISOString(), timeZone, date)
  const exact = check === minute ? corrected : corrected - (check - minute) * 60_000
  return new Date(exact).toISOString()
}
